module.exports = __webpack_public_path__ + "static/media/yiyuan6.8b129f25.png";